import { render, staticRenderFns } from "./ProcessSwitcher.vue?vue&type=template&id=dedad6f4&"
import script from "./ProcessSwitcher.vue?vue&type=script&lang=js&"
export * from "./ProcessSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports